export const getMenuData = [
  {
    title: 'Home',
    key: '__home',
    url: '/home',
    // icon: 'fe fe-home',
  },
  {
    title: 'About Us',
    key: '__about',
    icon: 'fe fe-info',
    children: [
      {
        title: 'Who we are',
        key: '__who_we_are',
        url: '/about/who-we-are',
      },
      {
        title: 'Chapters',
        key: '__chapters',
        url: '/about/chapters',
      },
      {
        title: 'Working Group',
        key: '__working_group',
        url: '/about/working-group',
      },
      {
        title: 'Inaheart member',
        key: '__inaheart_member',
        url: '/about/inaheart-member',
      },
      {
        title: 'Contact Us',
        key: '__contact_us',
        url: '/about/contact-us',
      },
    ],
  },
  {
    title: 'Guidelines, Publications & News',
    key: '__guidelines',
    icon: 'fe fe-file-text',
    children: [
      {
        title: 'Guidelines & Statements',
        key: '__guidelines_statements',
        url: '/guidelines/statements',
      },
      {
        title: 'Indonesian Journal of Cardiology',
        key: '__journal',
        url: '/guidelines/journal',
      },
      {
        title: 'News & Articles',
        key: '__news',
        url: '/guidelines/news',
      },
      {
        title: 'Events',
        key: '__events',
        url: '/guidelines/events',
      },
    ],
  },
  {
    title: 'Courses & Education (Coming Soon)',
    key: '__courses',
    icon: 'fe fe-book',
    children: [
      {
        title: 'ACLS Training',
        key: '__acls',
        url: '/courses/acls',
      },
      {
        title: 'Courses & Programs (Coming Soon)',
        key: '__programs',
        url: '/courses/programs',
      },
    ],
  },
  {
    title: 'Admin',
    key: '__admin',
    icon: 'fe fe-settings',
    roles: ['super_admin', 'admin'], // Hanya untuk super_admin dan admin
    children: [
      {
        title: 'User Management',
        key: '__user_management',
        url: '/admin/users',
        roles: ['super_admin', 'admin'],
      },
      {
        title: 'Group Management',
        key: '__group_management',
        url: '/admin/groups',
        roles: ['super_admin'], // Hanya untuk super_admin
      },
    ],
  },
]
